import React from 'react';
import { BsPlusLg } from 'react-icons/bs';
import { FaTrash } from 'react-icons/fa';

const SigorRelacionadas = (props) => {

  function add_classe(id) {
    if (!props.state.classes_selecionadas.filter(item => item.id === id)[0]) {
      const classe = props.state.classes.filter(item => item.id === id)[0]
      const classes = props.state.classes.filter(item => item.id !== id)

      const obj_classe = {
        id: classe.id,
        descricao: classe.nome,
      }

      props.setState({ ...props.state, classes_selecionadas: [...props.state.classes_selecionadas, obj_classe], classes, classe_id: classes[0].id })
    }
  }

  function remove_classe(id) {
    const classes_selecionadas = props.state.classes_selecionadas.filter(item => item.id !== id)
    const devolution = props.state.all_classes.filter(item => item.id === id)[0]
    let classes = [devolution, ...props.state.classes]

    props.setState({ ...props.state, classes_selecionadas, classes, classe_id: classes[0].id })
  }

  return (
    <div>
      {!props.state.loading ? <div className="form-group row">
        <label className="col-sm-12 col-form-label">Classes Relacionais</label>
        <div className="input-group col-sm-12">
          <select value={props.state.classe_id} className="form-control" id="cameras" onChange={(e) => props.setState({ ...props.state, classe_id: e.target.value })}>
            {props.state.classes.map(item => (
              <>{!item.relation && <option value={item.id}>{item.nome}</option>}</>
            ))}
          </select>
          <button className='btn btn-primary' onClick={() => add_classe(props.state.classe_id)}>
            <BsPlusLg />
          </button>
        </div>
      </div>
        :
        <div className="col-12 d-flex justify-content-center align-items-center" style={{ marginTop: '2rem' }}>
          <div className="spinner-border text-primary" role="status"></div>
        </div>}

      {props.state.classes_selecionadas.length > 0 &&
        <div className="row my-3">
          <div className="col-12">
            <table className='table table-striped table-hover text-center'>
              <thead>
                <th>Nome</th>
                <th>Ações</th>
              </thead>
              <tbody>
                {props.state.classes_selecionadas.map(item2 => (
                  <tr key={item2.id}>
                    <td>{item2.descricao}</td>
                    <td><button className="btn btn-danger btn-small btn-circle m-r-5"
                      onClick={() => remove_classe(item2.id)}>
                      <FaTrash color='white' />
                    </button>
                    </td>
                  </tr>
                ))}

              </tbody>
            </table>
          </div>
        </div>}
    </div>
  )
}

export default SigorRelacionadas